import type { ReactNode } from 'react'

import { Badge, Box } from '@percent/lemonade'
import classes from './Tags.module.scss'

export function Tags({
  tags,
  highlightFirstTag,
  children
}: Readonly<{ tags?: string[]; highlightFirstTag?: boolean; children?: ReactNode }>) {
  return (
    <Box data-testid="description-tags" className={classes.TagsWrapper}>
      {children}
      {tags?.map((tag, i) => (
        <Badge key={tag} variant={i === 0 && highlightFirstTag ? 'informative' : 'default'} shape="oval">
          {tag}
        </Badge>
      ))}
    </Box>
  )
}
